// Helpers for tier and risk colors
export const TIER_LABELS = {
  1: "Tier 1 Partial",
  2: "Tier 2 Risk-Informed",
  3: "Tier 3 Repeatable",
  4: "Tier 4 Adaptive",
};

export const TIER_COLORS = {
  1: { bg: "bg-red-500/10", text: "text-red-400", border: "border-red-500/30", solid: "#EF4444" },
  2: { bg: "bg-orange-500/10", text: "text-orange-400", border: "border-orange-500/30", solid: "#F97316" },
  3: { bg: "bg-yellow-500/10", text: "text-yellow-400", border: "border-yellow-500/30", solid: "#EAB308" },
  4: { bg: "bg-green-500/10", text: "text-green-400", border: "border-green-500/30", solid: "#22C55E" },
};

export function scoreToColor(score) {
  if (score < 1.5) return "#EF4444";
  if (score < 2.5) return "#F97316";
  if (score < 3.5) return "#EAB308";
  return "#22C55E";
}

export function scoreToBadge(score) {
  if (score < 1.5) return { className: "bg-red-500/10 text-red-400 border-red-500/30", label: "Critical" };
  if (score < 2.5) return { className: "bg-orange-500/10 text-orange-400 border-orange-500/30", label: "Moderate" };
  if (score < 3.5) return { className: "bg-yellow-500/10 text-yellow-400 border-yellow-500/30", label: "Developing" };
  return { className: "bg-green-500/10 text-green-400 border-green-500/30", label: "Mature" };
}

export const FUNCTION_COLORS = {
  GV: "#8B5CF6",
  ID: "#3B82F6",
  PR: "#06B6D4",
  DE: "#10B981",
  RS: "#F59E0B",
  RC: "#EF4444",
};

export const PRIORITY_BADGE = {
  critical: "bg-red-500/10 text-red-400 border-red-500/30",
  high: "bg-orange-500/10 text-orange-400 border-orange-500/30",
  medium: "bg-yellow-500/10 text-yellow-400 border-yellow-500/30",
  low: "bg-zinc-500/10 text-zinc-400 border-zinc-500/30",
};

export const STATUS_BADGE = {
  not_started: "bg-zinc-500/10 text-zinc-400 border-zinc-500/30",
  in_progress: "bg-blue-500/10 text-blue-400 border-blue-500/30",
  completed: "bg-green-500/10 text-green-400 border-green-500/30",
  deferred: "bg-orange-500/10 text-orange-400 border-orange-500/30",
};

export const ROLE_LABELS = {
  super_admin: "Super Admin",
  assessor: "Assessor",
  client_viewer: "Client Viewer",
};

export const IMPL_STATUS_LABELS = {
  not_implemented: "Not Implemented",
  ad_hoc: "Ad hoc / Reactive",
  defined: "Defined but Inconsistent",
  implemented: "Implemented & Repeatable",
  managed: "Managed & Measured",
  optimized: "Optimized",
};

export const EVIDENCE_TYPE_LABELS = {
  policy: "Policy",
  procedure: "Procedure",
  screenshot: "Screenshot",
  configuration_export: "Configuration Export",
  log_sample: "Log Sample",
  incident_report: "Incident Report",
  training_record: "Training Record",
  audit_report: "Audit Report",
  other: "Other",
};
